import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ifError } from 'assert';
import { AuthService } from '../auth.service'
import {ActivatedRoute, Router} from "@angular/router"
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss']
})
export class SigninComponent implements OnInit {
  authForm = new FormGroup({
    email: new FormControl('', [
      Validators.required,
      Validators.pattern(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/)
    ]),
    password: new FormControl('', [
      Validators.required,
      Validators.minLength(4),
      Validators.maxLength(20),
    ]),
  }
  );

  constructor(
    private authService: AuthService,
    private router: Router,
    private titleService:Title,
    private MetaService:Meta,
    private route: ActivatedRoute
  ) {
    this.titleService.setTitle(this.route.snapshot.data['title']);
    this.MetaService.updateTag(this.route.snapshot.data['metatags'])}

  ngOnInit() { }

  onSubmit(){
    localStorage.removeItem('anonyUser')
    if (this.authForm.invalid) {
      return;
    }
    this.authService.sigin(this.authForm.value).subscribe({
      next: response => {
         this.router.navigate([''])

      },
      error: err => {
        if (!err.status) {
          this.authForm.setErrors({ noConnection: true })
        } else if (err.status === 500) {
          this.authForm.setErrors({ wrongEmail: true })
        }
      }
    })
   
  }

  onClick(){
    localStorage.removeItem('anonyUser')
    this.authService.getTellerList().subscribe({ 
      next: response => {
        console.log('second result: ',response);
        
          this.router.navigate([''])

      },
      error: err => {
        if (!err) {
          console.log(' error : ', err);
        } else {
          console.log(' error : ', err);
        }
      }
    });
  } 
}
